import { TermsAndConditions } from 'components/Booking/Payment/Links'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import config from 'constants/config'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import React from 'react'
import Group from 'components/utils/Group'
import { Trans, useTranslation } from 'react-i18next'

const ReserveForZeroPolicyModalContent = () => {
  const { t } = useTranslation('hotelOfferList')
  return (
    <Group gap={24} direction="vertical">
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {t('Cancellation policy', { ns: 'hotelOfferList' })}
        </Heading>
        <BodyText variant="medium">
          {t('reserveForZeroPolicyModalContentCancellationPolicy', { ns: 'hotelOfferList' })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {t('Eligibility', { ns: 'hotelOfferList' })}
        </Heading>
        <BodyText variant="medium">
          {t('reserveForZeroEligibility', { ns: 'hotelOfferList', productType: config.productTypeLabelMap[OFFER_TYPE_HOTEL] })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {t('Maximum open reservations', { ns: 'hotelOfferList' })}
        </Heading>
        <BodyText variant="medium">
          {t('reserveForZeroPolicyModalContentMaximumOpenReservations')}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {t('Reservation fee', { ns: 'hotelOfferList' })}
        </Heading>
        <BodyText variant="medium">
          {t('reserveForZeroPolicyModalContentReservationFee', { ns: 'hotelOfferList' })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {t('Failed payments', { ns: 'hotelOfferList' })}
        </Heading>
        <BodyText variant="medium">
          {t('reserveForZeroPolicyModalContentFailedPayments', { ns: 'hotelOfferList' })}
        </BodyText>
      </Group>
      <BodyText variant="medium">
        <Trans i18nKey="reserveForZeroPolicyModalContentTerms" ns="hotelOfferList" brandName={config.brandConfig.name}>
          {config.brandConfig.name} T&C's apply - see <TermsAndConditions variant="black" />.
        </Trans>
      </BodyText>
    </Group>
  )
}

export default ReserveForZeroPolicyModalContent
